export interface IMessageDetail {
    messageDetailsId?: number;
    daiId1: string;
    daiId2?: string | null;
    loaiCuocId: string;
    soCuoc: string;
    soNhayTrung: number;
    lenSoCuoc: number;
    gia: number;
    hsThuong: number;
    khachAnPt: number;
    tuAnPt: number;   
    mienDaiCuocId: number;
    soGiai?: number ;
    messageId?: number ;
    diem?: number ;
    heSoNhan:1|-1;
}
export function MessageDetailsDefault(): IMessageDetail {
    return {
        messageDetailsId: undefined,
        daiId1: "",
        daiId2: "",
        loaiCuocId: "",
        soCuoc: "",
        soNhayTrung: 0,
        lenSoCuoc: 0,
        gia: 0,
        hsThuong: 0,
        khachAnPt: 0,
        tuAnPt: 0,
        mienDaiCuocId: 0,
        soGiai: 0,
        messageId: 0,
        diem: 0,
        heSoNhan:1,
    }
}